import {defineMessages, useIntl} from 'react-intl';

import {view} from '@sail/ui';

import type {Conversation} from '@stripe-internal/conversations-client';

import {useCurrentConversation} from '../../../core/hooks/appHooks';
import {useLiveChannelStatus} from '../../support/hooks/useLiveChannelStatus';

const messages = defineMessages({
  disclaimer: {
    id: 'conversations_assistant.footer.disclaimer',
    description: 'Disclaimer text footer for the ai assistant',
    defaultMessage: 'AI may make mistakes. Verify important information.',
  },
});

function DisclaimerContent({conversation}: {conversation: Conversation}) {
  const intl = useIntl();
  const {isLiveChatActive} = useLiveChannelStatus(conversation);

  if (isLiveChatActive) {
    return null;
  }

  return (
    <view.div
      css={{
        stack: 'y',
        alignX: 'center',
        color: 'form.placeholder',
        font: 'label.small',
        flexGrow: 0,
        width: 'fill',
        paddingX: 'space.200',
        paddingBottom: 'space.200',
        zIndex: 2, // sit on top of background wave
      }}
    >
      <view.div
        css={{
          textAlign: 'center',
          width: 'fill',
        }}
      >
        {intl.formatMessage(messages.disclaimer)}
      </view.div>
    </view.div>
  );
}

export const StripeAssistantDisclaimer = () => {
  const conversation = useCurrentConversation();

  if (!conversation) {
    return null;
  }

  return <DisclaimerContent conversation={conversation} />;
};
